import { useState } from "react"
import { withRouter } from "react-router-dom"
import { useMutation } from "@apollo/client"
import {
  GUEST_NAME_BY_USERS_MUTATION,
  GUEST_ORDERPRODUCTSEND_MUTATION,
} from "../../../../../../Config/Queries"

import styled, { css } from "styled-components"
import {
  Roundbox,
  Col,
  Ready,
  SearchContainer,
  SearchList,
  UserList,
  FormBox,
} from "../../../../../../styles/styles"
import Tabs, { TabPane } from "rc-tabs"
import { useForm } from "react-hook-form"
import Button from "../../../../../Buttons"
import theme from "../../../../../../styles/Theme"
import { graphqlUrl } from "../../../../../../Config/Env"
import { toast } from "react-toastify"
import { SearchNormal1 } from "iconsax-react"

const TabBars = styled.div`
  ${({ theme }) => {
    return css`
      .rc-tabs-nav {
        z-index: 999;
        padding: ${theme.paddings.base} ${theme.paddings.xl};
      }
      .rc-tabs-nav-operations {
        display: none;
      }
      .rc-tabs-nav-list {
        background-color: ${theme.colors.lightgray};
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        border-radius: 30px;
        padding: 3px;
      }
      .rc-tabs-tab {
        display: flex;
        flex: 1;
        .rc-tabs-tab-btn {
          position: relative;
          display: flex;
          flex: 1;
          height: 40px;
          justify-content: center;
          align-items: center;
          span {
            display: flex;
            align-items: center;
            color: ${theme.colors.black03};
            font-size: 15px;
          }
        }
      }
      .rc-tabs-tab-active {
        background-color: white;
        border-radius: 30px;
        .rc-tabs-tab-btn {
          span {
            color: ${theme.colors.primary};
            font-weight: ${theme.fonts.weight.bold};
          }
        }
      }
      .rc-tabs-ink-bar {
        display: none;
      }
    `
  }}
`
const PresentUserBox = styled.div`
  ${({ theme }) => {
    return css`
      border-radius: 16px;
      background-color: white;
      .bottom {
        padding: ${theme.paddings.lg} ${theme.paddings.xl};
      }
    `
  }}
`
const SUserList = styled(UserList)`
  ${({ theme }) => {
    return css`
      border-bottom: 0;
      padding: 0;
      ul {
        padding: 0 ${theme.paddings.xl};
        height: 150px;
        overflow-x: hidden;
        overflow-y: scroll;
        white-space: nowrap;
        flex-direction: column;
        ::-webkit-scrollbar {
          display: none;
        }
        li {
          display: flex;
          flex-direction: row;
          padding: ${theme.paddings.sm} 0;
          align-items: center;
          justify-content: center;
          border-bottom: solid 1px #eee;
          .left {
            flex: 1;
            font-size: ${theme.fonts.size.sm};
            color: ${theme.colors.black01};
            span {
              display: block;
              color: ${theme.colors.black04};
              font-weight: ${theme.fonts.weight.base};
            }
          }
          .right {
            width: 140px;
            text-align: right;
            justify-content: flex-end;
          }
        }
        .check_list_done {
          flex-direction: column;
        }
      }
    `
  }}
`
const renderTabBar = (props, DefaultTabBar) => (
  <TabBars>
    <DefaultTabBar {...props} />
  </TabBars>
)
function PresentUser({
  history,
  match,
  location,
  user,
  setUser,
  userAdd,
  userRemove,
}) {
  console.log(location?.state?.id)
  const id = location?.state?.id

  const [keyword, setKeyword] = useState("")
  const [searchUsers, setSearchUsers] = useState([])

  const [nameByUsersMutation, { loading }] = useMutation(
    GUEST_NAME_BY_USERS_MUTATION
  )
  const [orderProductSendMutation, { loading: sendLoading }] = useMutation(
    GUEST_ORDERPRODUCTSEND_MUTATION
  )

  const { register, handleSubmit, errors, setValue } = useForm({
    mode: "onChange",
  })

  const onSearch = async () => {
    if (keyword === "") {
      toast.error(`수신자 이름을 입력해주세요.`)
      return
    }
    setKeyword("")
    console.log({ keyword })
    try {
      const {
        data: {
          TicketGuestUserSeach: { users },
        },
      } = await nameByUsersMutation({
        variables: {
          keyword: keyword,
        },
      })
      setSearchUsers(users)
      return
    } catch (e) {
      console.log(e)
    }
  }
  const onSubmit = async (data) => {
    if (user?.phone === data.phone) {
      toast.error(`이미등록된 전화번호 입니다.`)
      return
    }

    const userObject = {
      isMember: false,
      id: null,
      name: data.name,
      phone: data.phone,
    }
    userAdd(userObject)
    setValue("name", "")
    setValue("phone", "")
  }
  const onSend = async () => {
    if (sendLoading) {
      return
    }
    if (!user) {
      toast.error(`티켓 받는분을 검색해주세요.`)
      return
    }

    const {
      data: { TicketGuestOrderProductSend },
    } = await orderProductSendMutation({
      variables: {
        id,
        user,
      },
    })

    if (TicketGuestOrderProductSend) {
      toast.success(`${user.name}님에게 티켓을 보냈습니다.`)
      history.replace(`/home`)
    }
  }

  return (
    <>
      <PresentUserBox>
        <SUserList>
          <ul>
            {user ? (
              <li>
                <div className="left">
                  {user.isMember ? (
                    <>
                      <b>{user.name}님</b>
                      <span>{user.userId}</span>
                    </>
                  ) : (
                    <>
                      <b>{user.name}님</b>
                      <span>{user.userId}</span>
                    </>
                  )}
                </div>
                <div className="right">
                  <Button
                    type="button"
                    color="danger"
                    border="solid"
                    size="xs"
                    onClick={() => userRemove(user)}
                  >
                    삭제
                  </Button>
                </div>
              </li>
            ) : (
              <li className="check_list_done">
                <Roundbox>
                  <div className="icon"></div>
                </Roundbox>
                <div className="cont">
                  <p>수신자를 검색해주세요.</p>
                </div>
              </li>
            )}
          </ul>
        </SUserList>

        <Tabs defaultActiveKey="1" renderTabBar={renderTabBar}>
          <TabPane tab={<span>회원</span>} key="1">
            <SearchContainer>
              <form>
                <div className="inner">
                  <button
                    type="button"
                    onClick={onSearch}
                    className="searchBtn"
                  >
                    <SearchNormal1
                      color={theme.colors.black02}
                      variant="Linear"
                      size={20}
                    />
                  </button>
                  <input
                    type="text"
                    name="keyword"
                    placeholder="이름 입력"
                    value={keyword}
                    onChange={(e) => {
                      setKeyword(e.target.value)
                    }}
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault()
                        onSearch()
                      }
                    }}
                  />
                </div>
              </form>
            </SearchContainer>

            <SearchList>
              {searchUsers.length > 0 ? (
                <ul>
                  {searchUsers.map((item, index) => {
                    const avatarImage =
                      item.avatar === ""
                        ? "/assets/img/product/product-default.jpg"
                        : `${graphqlUrl}${item.avatar}`
                    return (
                      <li key={index}>
                        <label>
                          <Roundbox>
                            <div className="img">
                              <img src={avatarImage} alt={item.name} />
                            </div>
                          </Roundbox>
                          <input
                            type="checkbox"
                            onChange={() => {
                              const user = {
                                isMember: true,
                                id: item.id,
                                userId: item.userId,
                                name: item.name,
                                phone: item.phone,
                              }
                              userAdd(user)
                            }}
                            checked={user?.id === item.id}
                          />
                          <p className="name">
                            {item.role === "User" && (
                              <>
                                {item.name}님<span>({item.userId})</span>
                              </>
                            )}
                            {item.role === "Store" && (
                              <>
                                {item.store.name} - {item.name}님
                                <span>({item.userId})</span>
                              </>
                            )}
                          </p>
                        </label>
                      </li>
                    )
                  })}
                </ul>
              ) : (
                <Ready>
                  <div className="list_none">검색어를 입력해주세요.</div>
                </Ready>
              )}
            </SearchList>
          </TabPane>
          <TabPane tab={<span>비회원</span>} key="2">
            <FormBox>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form_group">
                  <label>이름</label>
                  <input
                    type="text"
                    name="name"
                    placeholder="이름"
                    ref={register({
                      required: "이름를 입력해주세요.",
                    })}
                  />
                </div>
                <div className="form_group">
                  <label>전화번호</label>
                  <input
                    type="text"
                    name="phone"
                    placeholder="전화번호 ‘-’제외"
                    ref={register({
                      required: "전화번호를 입력해주세요.",
                    })}
                  />
                </div>
                <Button
                  type="submit"
                  color="primary"
                  border="solid"
                  size="sm"
                  width="full"
                >
                  추가
                </Button>
              </form>
            </FormBox>
          </TabPane>
        </Tabs>
        <div className="bottom">
          <Button
            disabled={sendLoading}
            onClick={onSend}
            color="primary"
            size="lg"
            width="full"
          >
            {sendLoading ? "처리중..." : "확인"}
          </Button>
        </div>
      </PresentUserBox>
    </>
  )
}

export default withRouter(PresentUser)
